import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpeg'
import {FaAward} from 'react-icons/fa'
import {HiOutlineUsers} from 'react-icons/hi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
 
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Education</h5>
              <small>Pursuing PhD @ IITG, BTech @ CITK </small>
            </article>

            <article className='about__card'>
              <HiOutlineUsers className='about__icon' />
              <h5>Role</h5>
              <small>Open for collaborations</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
          </div>
          <p>
          I am a PhD scholar in Computer Science and Engineering at IIT Guwahati, driven by a passion for research at the intersection of intelligent systems and human-centered computing. My academic and research interests lie primarily in Machine Learning for Electronic Design Automation (EDA), Human-Computer Interaction (HCI), and Natural Language Processing (NLP). I am particularly interested in how data-driven approaches can be used to automate, optimize, and enhance both the physical design of digital systems and the ways humans interact with technology. Whether it’s applying deep learning techniques to improve VLSI design workflows or exploring emotion-aware systems that adapt to user behavior, I enjoy working on problems that blend theory, engineering, and human impact. I strive to contribute to the development of systems that are not only technically robust but also intuitive and accessible.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
          
        </div>
      </div>
    </section>
  )
}

export default About